import books from "~/dummy-data/books";

export const data: Record<string, any> = {
  ...books,
};
